import * as ss from "simple-statistics";

import { groupBy, sortBy } from "lodash";
import { addDay, formatDay, startDay } from "./date";


import { Quote, StrategyOutput, Trade } from "../../types";
import { Spread } from "./ibkr";

export const capitalStart = 100_000; // Real 40 000 USD plus financial leverage

export function getResultsClosed(results: StrategyOutput[]) {
    return results
        .map(r => ({ ...r.decision, ...r.result }))
        .filter(r => r.typeClose !== "not-open")
        .sort((a, b) => a.dateClose - b.dateClose);
}

export function getGain({ open, close }: { open: number; close: number }) {
    return close / open - 1;
}

export function getGainPrice({ close, open, price }: { close: number; open: number; price: number }) {
    return price * getGain({ open, close });
}

export function getTrade(result: StrategyOutput, quote?: Quote): Trade {
    const symbol = result.symbol;
    const openLow = result.decision.openLow;
    const openHigh = result.decision.openHigh;
    const takeProfit = result.decision.takeProfit;
    const stopLoss = result.decision.stopLoss;
    const bidAskSpread = quote?.bidAskSpread || null;
    const bidAskSpreadPercent = bidAskSpread ? bidAskSpread / openHigh : null;
    const askPrice = quote?.AskPrice || null;
    const askSize = quote?.AskSize || null;
    const bidPrice = quote?.BidPrice || null;
    const bidSize = quote?.BidSize || null;

    const open = ss.average([openLow, openHigh]);
    const takeProfitPercent = (takeProfit / open) - 1;
    const stopLossPercent = (stopLoss / open) - 1;

    const isQuote = !!quote;
    const isBidAskSpread = bidAskSpread !== null;
    // TODO: less than 1%
    const isEnoughSpread = bidAskSpread ? bidAskSpread / open < 0.01 : false;

    return {
        strategyName: result.strategyName,
        symbol,
        dateFound: result.date,
        openLow,
        openHigh,
        takeProfit,
        stopLoss,
        bidAskSpread,
        bidAskSpreadPercent,
        askPrice,
        askSize,
        bidPrice,
        bidSize,
        takeProfitPercent,
        stopLossPercent,
        isQuote,
        isBidAskSpread,
        isEnoughSpread,
        lastPrice: null,
    };
}

export function getTradeFromSpread(result: StrategyOutput, orderPriceLimit: number, spread?: Spread): Trade {
    const symbol = result.symbol;
    const openLow = result.decision.openLow;
    const openHigh = result.decision.openHigh;
    const takeProfit = result.decision.takeProfit;
    const stopLoss = result.decision.stopLoss;
    const bidAskSpread = spread?.bidAskSpread || null;
    const bidAskSpreadPercent = spread?.bidAskSpreadPercent || null;

    const askPrice = spread?.ask || null;
    const askSize = spread?.askSize || null;
    const bidPrice = spread?.bid || null;
    const bidSize = spread?.bidSize || null;

    const open = ss.average([openLow, openHigh]);
    const takeProfitPercent = (takeProfit / open) - 1;
    const stopLossPercent = (stopLoss / open) - 1;

    const isQuote = !!spread;
    const isBidAskSpread = bidAskSpread !== null;
    // TODO: less than 1.0%
    const isEnoughSpread = bidAskSpread ? bidAskSpread / open < orderPriceLimit : false;

    return {
        strategyName: result.strategyName,
        symbol,
        dateFound: result.date,
        openLow,
        openHigh,
        takeProfit,
        stopLoss,
        bidAskSpread,
        bidAskSpreadPercent,
        askPrice,
        askSize,
        bidPrice,
        bidSize,
        takeProfitPercent,
        stopLossPercent,
        isQuote,
        isBidAskSpread,
        isEnoughSpread,
        lastPrice: spread?.last || null,
    };
}

type CapitalProgress = {
    date: number;
    capital: number;
    freeFunds: number;
    tradesNumber: number;
};


// TODO: not finished!
export function getCapitalProgress(capitalStart: number, outputs: StrategyOutput[]) {
    if (outputs.length === 0) return [];

    const capitalProgress: CapitalProgress[] = [];

    const dates = outputs.map(r => r.date);
    const dateFrom = startDay(ss.min(dates));
    const dateTo = addDay(ss.max(dates));

    const outputsGrouped = groupBy(outputs, r => formatDay(r.date));

    let capital = capitalStart;
    let freeFunds = capitalStart;

    for (let date = dateFrom; date <= dateTo; date = addDay(date)) {
        const day = formatDay(date);

        let tradesNumber = 0;

        const cp: CapitalProgress = {
            date,
            capital,
            freeFunds,
            tradesNumber,
        };

        if (outputsGrouped[day]) {
            // TODO: nemůžu vědět, že nebude otevřena!!!
            const results = getResultsClosed(outputsGrouped[day]);
            const sortedResults = sortBy(results, r => getGainPrice({ open: r.openHigh, close: r.takeProfit, price: r.price })); // best potencial profit

            for (const result of sortedResults) {
                if (freeFunds < result.price)
                    continue;


            }
        }

        capitalProgress.push(cp);
    }

    return capitalProgress;
}
